export const PARTNER_TASK_CARDS = {
  llc_formation: {
    titleId: 'dashboard.partnerNextUp.llcFormation.title',
    descriptionId: 'dashboard.partnerNextUp.llcFormation.description',
    ctaUrl: '#', // tbd
    imageUrl: '/illustration/next-up-finish-your-formation.svg',
    estimate: '10',
    ctaType: null
  },
  change_of_registered_agent: {
    titleId: 'dashboard.partnerNextUp.registeredAgent.title',
    descriptionId: 'dashboard.partnerNextUp.registeredAgent.description',
    ctaUrl: '#', // tbd
    imageUrl: '/illustration/next-up-finish-your-formation.svg',
    estimate: '5',
    ctaType: null
  },
  ein_creation: {
    titleId: 'dashboard.partnerNextUp.einCreation.title',
    descriptionId: 'dashboard.partnerNextUp.einCreation.description',
    ctaUrl: '#', // tbd
    imageUrl: '/illustration/next-up-finish-your-formation.svg',
    estimate: '10',
    ctaType: null
  }
};
